import { render, staticRenderFns } from "./activities-inside.vue?vue&type=template&id=19c4f458&scoped=true&"
import script from "./activities-inside.vue?vue&type=script&lang=js&"
export * from "./activities-inside.vue?vue&type=script&lang=js&"
import style0 from "./activities-inside.vue?vue&type=style&index=0&id=19c4f458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4f458",
  null
  
)

export default component.exports